import { supabase } from "../lib/supabase";

export type RoadmapInvokeResult = {
  ok?: boolean;
  error?: string;
  id?: string;
  is_prioritized?: boolean;
};

export async function invokeRoadmap(
  body: Record<string, unknown>
): Promise<RoadmapInvokeResult> {
  const { data, error } = await supabase.functions.invoke<RoadmapInvokeResult>(
    "roadmap",
    { body }
  );
  if (error) {
    throw new Error(error.message);
  }
  if (data && typeof data === "object" && "error" in data && data.error) {
    throw new Error(String(data.error));
  }
  return data ?? {};
}
